import { handleCrossDomainLink } from "../util/share";
import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { apiConfig } from "../config/apiConfig";

type address = {
    locationDoingBusinessAs: string,
    address: string,
    address2: string,
    state: string,
    country: string,
    city: string,
    zip: string,
    stateLicenseNumbers: string,
    displayAddressSwitch: boolean
}
export class DisplayAddress {
    hostname: string;
    isLower: boolean;

    webLocationResponse: any;
    brandData: any;
    constructor(webLocationResponse: any) {
        this.hostname = window.location.hostname;
        this.isLower = (this.hostname.indexOf("nblydev") != -1 || this.hostname.indexOf("nblysbx") != -1 || this.hostname.indexOf("nblytest") != -1);
        if (webLocationResponse)
        this.getFullAttributeData(webLocationResponse);
    }

    static async create() {
        const localWebID = localStorage.getItem("franchiseWebLocationId");
        const webID = document.getElementById('weblocationId') as HTMLInputElement;
        const weblocationID = (webID?.value ? webID?.value : localWebID);
        let webLocationResponse = null, brandData = null;
        if(weblocationID) {
            const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${weblocationID}`;
            webLocationResponse = await cachedAPIWrapper(url);
        }
        return new DisplayAddress(webLocationResponse);
    }

    private getFullAttributeData(response: any) {
        localStorage.setItem("fullAttrOnLoad", JSON.stringify(response));
        const sRedirectURL = response?.locationWebsiteUrl ?? "";
        // Set the localStorage item for the Header & Footer logo URL link
        if(sRedirectURL){
            handleCrossDomainLink(sRedirectURL);
        }
        this.displayAddressHandler(response);
        this.displayPhoneNumber(response);

        const sessionBrandData = sessionStorage.getItem('brandDetails');
        const brandData = sessionBrandData ? JSON.parse(sessionBrandData) : {};  


        const mapOnOffSwitch = response?.options?.mapOnOffSwitch;
        if(brandData?.check_map_ces){
            if(!mapOnOffSwitch && response?.options?.hasOwnProperty("mapOnOffSwitch")){
                document.querySelectorAll('.map-img-box')?.forEach((element)=> element?.remove())
            }
        }
    }

    public displayPhoneNumber(data: any) {
        let phoneNumber:any;
        if(data?.callTrackings?.length !=0){
            data?.callTrackings?.forEach((type:any)=>{
                if(type.callTrackingTypeDescription === "WebsiteTracking"){
                    phoneNumber = type.callTrackingNumber;
            }
            });
        }
        if(!phoneNumber){
            phoneNumber = data.mainPhoneNumber;
        }
        
        const phoneFormat:any = this.formatPhoneNumber(phoneNumber);
        const mobNumber = document.querySelector('.icon-block-text .card-text') as HTMLAnchorElement;

        if (phoneFormat && mobNumber) {
            mobNumber.innerHTML = phoneFormat;
            mobNumber.href = `tel:${phoneNumber}`;
        }
        return mobNumber
    }

    public formatPhoneNumber(phoneNumberString:any) {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          const intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
    }

    public displayAddressHandler(data: address) {
        if (!data) return;
        const { locationDoingBusinessAs, address, address2, state, city, zip, stateLicenseNumbers, displayAddressSwitch } = data;
        const addressContainer: any = document.querySelector('.contact-info .icon-block-text');
        if(addressContainer){
            addressContainer.innerHTML = ''; // Clearing existing contents
            const formattedAddress = `${city}, ${state} ${zip}`;

            const addressElement = document.createElement('address');

            const titleElement = document.createElement('p');
            titleElement.className = 'card-title';
            titleElement.textContent = locationDoingBusinessAs;

            const addressLine1Element = document.createElement('p');
            addressLine1Element.className = 'card-subtitle';
            addressLine1Element.textContent = address;

            const addressLine2Element = document.createElement('p');
            addressLine2Element.className = 'card-subtitle';
            addressLine2Element.textContent = address2;

            const formattedAddressElement = document.createElement('p');
            formattedAddressElement.className = 'card-subtitle';
            formattedAddressElement.textContent = formattedAddress;

            const licenseNumberElement = document.createElement('p');
            licenseNumberElement.className = 'card-subtitle';
            licenseNumberElement.textContent = (stateLicenseNumbers[0] != null) ? `License #${stateLicenseNumbers}` : '';

            addressElement.appendChild(titleElement);

            if(displayAddressSwitch){
            addressElement.appendChild(addressLine1Element);
            addressElement.appendChild(addressLine2Element);
            }

            addressElement.appendChild(formattedAddressElement);
            addressElement.appendChild(licenseNumberElement);

            addressContainer.appendChild(addressElement);
        }
    }
}

(async () => {
     if (!(globalThis as any).__DisplayAddressInitialized) {
        (globalThis as any).__DisplayAddressInitialized = true;
        await DisplayAddress.create();
    }
})();